import { render, staticRenderFns } from "./Atenciones.vue?vue&type=template&id=4e167580&scoped=true&"
import script from "./Atenciones.vue?vue&type=script&lang=js&"
export * from "./Atenciones.vue?vue&type=script&lang=js&"
import style0 from "./Atenciones.vue?vue&type=style&index=0&id=4e167580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e167580",
  null
  
)

export default component.exports